<script>
/**
 * @overview 七牛上传组件 - 视频预览
 *
 * @author huojinzhao
 */

export default {
  name: "AppQiniuPreviewVideo",

  props: {
    src: {
      type: String,
      required: true,
    },
  },

  methods: {
    preview() {
      const message = this.$createElement(
        "video",
        {
          domProps: {
            src: this.src,
            preload: "auto",
            controls: "controls",
          },
          style: {
            width: "100%",
            height: "100%",
          },
          key: Math.floor(Math.random() * (10 ** 10)),
        },
      );

      this.$msgbox({
        title: "视频在线预览",
        customClass: "app-qiniu__preview-video__dialog",
        message,
        showCancelButton: false,
        showConfirmButton: false,
      })
        .catch(() => {
          message.elm.pause();
        });
    },
  },
};
</script>

<template>
  <video
    :src="src"
    class="app-qiniu__preview-video"
  />
</template>

<style lang="postcss">
.app-qiniu__preview-video {
  min-height: 0;
}

.app-qiniu__preview-video__dialog {
  width: 630px;
  height: 450px;
}
</style>
